export const TRAINING_PLAN_ROOT = '/training-plans';
export const TRAINING_PLAN_BY_ID = `${TRAINING_PLAN_ROOT}/:trainingPlanId/:planSection?`;

const ROUTE_PATHS = {
  TRAINING_PLAN_BY_ID
};

export default ROUTE_PATHS;